import { useContext, useEffect, useState } from "react"
import ReactVisibilitySensor from "react-visibility-sensor"
import { LangContext } from "../../../App";

const chartDataEn = {
    asideLable : "Total Exposure SAR' (000)",
    yAxis : [
        "50,000,000",
        "45,000,000", 
        "40,000,000", 
        "35,000,000", 
        "30,000,000", 
        "25,000,000", 
        "20,000,000", 
        "15,000,000", 
        "10,000,000", 
        "5,000,000", 
        "0", 
    ],
    xAxis : [
        "Government and quasi government", 
        "Finance", 
        "Agriculture and fishing", 
        "Manufacturing", 
        "Mining and quarrying", 
        "Electricity,water,gas and health services", 
        "Building and construction", 
        "Commerce", 
        "Transportation and communication", 
        "Services", 
        "Credit cards and other retial lending", 
        "Others"
    ],
    data : [
        [
            800,
            150,
            0,
        ],
        [
            9650,
            12000,
            11550,
        ],
        [
            650,
            450,
            650,
        ],
        [
            24650,
            23550,
            22450,
        ],
        [
            3700,
            5150,
            7200,
        ],
        [
            12750,
            16150,
            20800,
        ],
        [
            10750,
            12700,
            16700,
        ],
        [
            39550,
            44150,
            52450,
        ],
        [
            14000,
            11100,
            13000,
        ],
        [
            9850,
            9550,
            10750,
        ],
        [
            40450,
            47450,
            55050,
        ],
        [
            3650,
            3000,
            7750,
        ]
    ],
    maxValue : 50000
}

const chartDataAr = {
    asideLable : "إجمالي القيمة المعرضة للمخاطر (بالألف ريال سعودي)",
    yAxis : [
        "50,000,000",
        "45,000,000", 
        "40,000,000", 
        "35,000,000", 
        "30,000,000", 
        "25,000,000", 
        "20,000,000", 
        "15,000,000", 
        "10,000,000", 
        "5,000,000", 
        "0", 
    ],
    xAxis : [
        "الحكومية وشبه الحكومية", 
        "التمويل", 
        "الزراعة والحراجة وصيد الأسماك", 
        "الصناعات التحويلية", 
        "التعدين واستغلال المحاجر", 
        "إمدادات الكهرباء والغاز والخدمات الصحية", 
        "البناء والتشييد", 
        "التجارة", 
        "النقل والاتصالات", 
        "الخدمات", 
        "بطاقات الائتمان وتمويل الأفراد", 
        "قطاعات أخرى"
    ],
    data : [
        [
            800,
            150,
            0,
        ],
        [
            9650,
            12000,
            11550,
        ],
        [
            650,
            450,
            650,
        ],
        [
            24650,
            23550,
            22450,
        ],
        [
            3700,
            5150,
            7200,
        ],
        [
            12750,
            16150,
            20800,
        ],
        [
            10750,
            12700,
            16700,
        ],
        [
            39550,
            44150,
            52450,
        ],
        [
            14000,
            11100,
            13000,
        ],
        [
            9850,
            9550,
            10750,
        ],
        [
            40450,
            47450,
            55050,
        ],
        [
            3650,
            3000,
            7750,
        ]
    ],
    maxValue : 50000
}

const ChartThree = () => {
    const { lang } = useContext(LangContext);
    const [chartData, setChartData] = useState(chartDataEn);

    useEffect(() => {
        setChartData(lang ? chartDataAr : chartDataEn)
    }, [lang])

  return (
    <>
    <div className="chart-wrapper">
    <div className={`chart-three ${lang ? "rtl" : ""}`}>
        <div className="chart-wrapper-one">
            <div className="aside-label-container">
                <p className="aside-label">{chartData.asideLable}</p>
            </div>
            <div className="y-labels">
                {chartData.yAxis.map((item, index) => (
                    <ReactVisibilitySensor key={index}>
                        {({isVisible} : any) => (
                            <p key={index} className={`y-lable an-move-left-fade-in an-d-${index} ${isVisible ? "an-active" : ""}`}>{item}</p>
                        )}
                    </ReactVisibilitySensor>
                ))}
            </div>

            <div className="chart-wrapper-two">
            <div className="plan">
                {
                chartData.data.map((item, index) => (
                    <div className="column-group" key={index}>
                    <ReactVisibilitySensor
                        partialVisibility
                    >
                    {({isVisible} : any) => (
                        <div className={`col column-${0} ${isVisible ? "visible" : ""}`} style={{ height : `${item[0] * 100 / chartData.maxValue}%`}}></div> 
                    )}
                    </ReactVisibilitySensor>
                    <ReactVisibilitySensor
                        partialVisibility
                    >
                    {({isVisible} : any) => (
                        <div className={`col column-${1} ${isVisible ? "visible" : ""}`} style={{ height : `${item[1] * 100 / chartData.maxValue}%`}}></div>
                         
                    )}
                    </ReactVisibilitySensor>
                    <ReactVisibilitySensor
                        partialVisibility
                    >
                    {({isVisible} : any) => (
                        <div className={`col column-${2} ${isVisible ? "visible" : ""}`} style={{ height : `${item[2] * 100 / chartData.maxValue}%`}}></div> 
                    )}
                    </ReactVisibilitySensor>
                    </div>
                ))
                }
            </div>
            <div className="x-labels">
                {chartData.xAxis.map((item, index) => (
                    <div key={index} className="x-label">
                        <p className="x-label-text">{item}</p>
                    </div>
                ))}
            </div>
            </div>
        </div>
    </div>
    </div>
    <div className="chart-keys-wrapper">
        <div className="flex">
            <ReactVisibilitySensor
                partialVisibility
            >
            {({isVisible} : any) => (
                <div className={`key-label an-move-left-fade-in an-d-1 ${isVisible ? "an-active" : ""}`}>
                    <div className="key-color bg-blue"></div>
                    <p className="key-label">{!lang ? "Total exposure 2021" : "إجمالي القيمة المعرضة للمخاطر في عام 2021"}</p>
                </div>
            )}
            </ReactVisibilitySensor>
            <ReactVisibilitySensor
                partialVisibility
            >
            {({isVisible} : any) => (
                <div className={`key-label an-move-left-fade-in an-d-2 ${isVisible ? "an-active" : ""}`}>
                    <div className="key-color bg-gray"></div>
                    <p className="key-label">{!lang ? "Total exposure 2022" : "إجمالي القيمة المعرضة للمخاطر في عام 2022"}</p>
                </div>
            )}
            </ReactVisibilitySensor>
            <ReactVisibilitySensor
                partialVisibility
            >
            {({isVisible} : any) => (
                <div className={`key-label an-move-left-fade-in an-d-3 ${isVisible ? "an-active" : ""}`}>
                    <div className="key-color bg-green"></div>
                    <p className="key-label">{!lang ? "Total exposure 2023" : "إجمالي القيمة المعرضة للمخاطر في عام 2023"}</p>
                </div>
            )}
            </ReactVisibilitySensor>
        </div>
    </div>
    </>
  )
}

export default ChartThree